import { render } from "./Additional-product.vue?vue&type=template&id=1ee4b378&scoped=true"
import script from "./Additional-product.vue?vue&type=script&lang=js"
export * from "./Additional-product.vue?vue&type=script&lang=js"

import "./Additional-product.vue?vue&type=style&index=0&id=1ee4b378&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee4b378"]])

export default __exports__